module.exports = __webpack_public_path__ + "assets/a56de72a62da5807b5c57f7be82054bd.mp3";